module.exports = __webpack_public_path__ + "img/Trophy Cup Table33.821b4926.jpg";